<template>
    <div id="EditJikeng">
        <el-dialog title="结构信息" :visible.sync="dialogEdit.show" width="620px" ref="dialog" @opened="opened()"
                   :modal-append-to-body="false" :modal="false">
            <el-form ref="formEdit" :model="form" label-width="80px">
                <input type="hidden" name="pitNo">
                <div style="width: 280px; float: left;">
                    <div class="form-group">
                        <label>所属项目</label>
                        <el-select v-model="projectName" value-key="id"  class="select" @change="selectProjectId">
                            <el-option v-for="item in this.pInfo" :key="item.id" :label="item.name" :value="item"></el-option>
                        </el-select>
					</div>
					<!-- <div class="form-group">
						<label>结构模型文件</label> <img id="imgview" style="width: 280px" src="../../assets/image/add_bg.png"><br />
                            <el-button type="primary" size="small">选择文件</el-button>
							<input type="file" name="modalfile" style="display: none">
					</div> -->
					<div class="form-inline">
						<div class="form-group">
							<label>类型:</label>
                            <el-select v-model="typeName"  value-key="id"  class="select" @change="selectType">
                                <el-option v-for="item in this.types" :key="item.id" :label="item.value" :value="item"></el-option>
                            </el-select>
						</div>
					</div>
                    <div class="form-inline">
						<div class="form-group">
							<label>描述:</label>
              <el-input v-model="form.description"></el-input>
						</div>
					</div>
                    <div class="form-inline">
						<div class="form-group">
							<label>系统:</label>
                  <el-select v-model="systemTypeName"  disabled value-key="id" class="select" @change="selectSystemType">
                        <el-option v-for="item in this.systems" :key="item.id" :label="item.value" :value="item"></el-option>
                  </el-select>
						</div>
					</div>
           <div class="form-inline">
						<div class="form-group" v-if="show3d">
							<label>3D编号</label>
              <el-input v-model="form.bimfaceModelId"></el-input>
						</div>
             <div class="form-group" v-if="show2d">
               <label>2D图片</label>
               <el-upload
                 :before-upload="beforeAvatarUpload"
                 list-type="picture"
                 :on-preview="handlePictureCardPreview"
                 :limit="1"
                 :multiple="true"
                 accept=".jpg,.png"
                 action="/api/monitor/fileUpload/uploadImage"
                 :data="uploadData"
                 :on-exceed="handleExceed"
                 :on-success="handleAvatarSuccess"
                 :on-remove="handleRemove"
                 :file-list="fileList">
                 <el-button size="small" type="primary">上传图片</el-button>
               </el-upload>
               <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
                 <img width="100%" :src="dialogImageUrl" alt="">
               </el-dialog>
             </div>
<!--               <div class="form-group">-->
<!--                   <label>模型编号</label>-->
<!--                   <el-input v-model="form.bimfaceModelId"></el-input>-->
<!--               </div>-->
					</div>
					</div>
					<div style="width: 280px; float: right;">
						<div class="form-group">
							<label>结构名称</label>
                            <el-input v-model="form.name"></el-input>
						</div>
						<div class="form-group">
							<label>坐标选取</label>
              <div id="r-result">输入搜索:<input type="text" id="suggestId" size="40" @change="changeLat()" value="" style="width:180px;"/></div>
              <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
							<div id="map"></div>
							<div>
                                经度：<span id="lng">{{lng}}</span>
                                纬度：<span id="lat">{{lat}}</span>
							</div>
						</div>
					</div>
					<div style="clear: both"></div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEdit.show = false">取消</el-button>
                <el-button type="primary" @click="dialogFormEdit('formEdit')">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import $ from 'jquery'
    let newLng = ''; let newLat = '';  // 设置全局变量才能拿得到经纬度

    export default {
        name: 'EditJikeng',
        props:{
            dialogEdit:Object,
            form:Object,
            pInfo:{
                Type:Array,
                default: () => []
            },
            types:{
               Type:Array,
               default: () => []
            },
            systems:{
               Type:Array,
               default: () => []
            }
        },
        data () {
            return {
                show3d:false,
                show2d:false,
                imgUrl:'',
                dialogVisible:false,//图片预览
                dialogImageUrl:'', //预览地址
                fileList: [],
                image_str:'',
                uploadData: {},
                projectName:'', // 所属项目
                typeName:'', // 类型
                systemTypeName:'', // 系统
                lng:'',
                lat:'',
            }
        },
        mounted:function(){
            this.imgUrl = localStorage.getItem("url")
        },
        methods:{
            handleAvatarSuccess(res, file) {
                this.image_str = res.datas.values
                console.log(this.image_str)
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传图片不能超过2M');
                }
                return isLt2M;
            },
            handleExceed(files, fileList) {
                this.$message.warning(`最多只能上传一张图片!`);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
                // console.log(file.url,file)

            },
            handleRemove(file, fileList) {
                if (this.image_str.includes(file.response)) {
                    this.image_str = this.image_str.replace(`${file.response}_`, '');
                }
            },
            selectProjectId(e){
                this.form.projectId = e.id;
                this.form.projectName=e.name
            },
            selectType(e){
                this.form.type = e.id;
            },
            selectSystemType(e){
                if(e.id==1){
                    this.show3d=true
                    this.show2d=false
                }else{
                    this.show2d=true
                    this.show3d=false
                }
               this.form.systemType = e.id;
            },
            opened(){
                // 刚打开弹框，直接后端接口返回这三个字段
                // console.log(this.form,5555)
                this.projectName = this.form.projectName;
                // this.typeName = this.form.typeName;
                this.types.forEach(item=>{
                    if(item.id===this.form.typeName){
                        this.typeName=item.value
                    }
                })
                // if(this.form.systemType==){
                //
                // }
                if(this.form.systemType==1){
                    this.show3d=true
                    this.show2d=false
                }else{
                    this.show2d=true
                    this.show3d=false
                }
                this.fileList=[]
                this.image_str=this.form.projectPicPath
                let obj ={
                    url:this.imgUrl+this.form.projectPicPath,
                    name:'img-001'
                }
                this.fileList.push(obj)
                this.systemTypeName = this.form.systemType=='1'? '3D':'2D'
                function G(id) {
                    return document.getElementById(id);
                }
                var map = new BMap.Map("map");
                map.disableAutoResize();
                // console.log(this.form,111)
                let point = new BMap.Point(this.form.coordinate.split(',')[0], this.form.coordinate.split(',')[1]);
                this.lng = this.form.coordinate.split(',')[0]
                this.lat = this.form.coordinate.split(',')[1]
                map.centerAndZoom(point, 12);
                map.enableScrollWheelZoom(true);
                map.clearOverlays();
                map.addOverlay(new BMap.Marker(point));    //添加标注
                var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
                    {"input" : "suggestId"
                        ,"location" : map
                    });
                ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
                    var str = "";
                    var _value = e.fromitem.value;
                    var value = "";
                    if (e.fromitem.index > -1) {
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

                    value = "";
                    if (e.toitem.index > -1) {
                        _value = e.toitem.value;
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                    G("searchResultPanel").innerHTML = str;
                });

                var myValue;
                ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
                    // console.log(local.getResults().getPoi(0).point)
                    var _value = e.item.value;
                    myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    G("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                    setPlace();
                });
                function setPlace() {
                    map.clearOverlays();    //清除地图上所有覆盖物
                    function myFun() {
                        var pp = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
                        map.centerAndZoom(pp, 12);
                        map.addOverlay(new BMap.Marker(pp));    //添加标注
                    }
                    var local = new BMap.LocalSearch(map, { //智能搜索
                        onSearchComplete: myFun
                    });
                    local.search(myValue);
                }
                const _this = this  // 注意：这里须这样写，否则不会同步数据，百度下怎么回事
                //单击获取点击的经纬度
                map.addEventListener("click",function(e){
                    map.clearOverlays();
                    map.addOverlay(new BMap.Marker(e.point));
                    _this.lng = e.point.lng;
                    _this.lat = e.point.lat;
                    newLng = e.point.lng;
                    newLat = e.point.lat;
                });
            },
            changeLat(){
                setTimeout(()=>{
                    this.lng ='';
                    this.lat = '';
                },100)
            },
            dialogFormEdit(formEdit){
                this.form.projectPicPath = this.image_str;
                // this.form.imageStr = this.image_str;
                //  经纬度用逗号拼接起来,如果改了坐标，就发新坐标，否则发原有坐标
                if(newLng != ""){
                    let coordinate = "";
                    coordinate = newLng + ',' + newLat;
                    this.form.coordinate = coordinate;
                }
                this.$axios.post('/api/monitor/project/child/updateChildProject',this.form).then(res => {
                    if(res.data.status == 200){
                        this.$message({
                            type: "success",
                            message: res.data.datas.values
                        });
                        this.dialogEdit.show = false;
                        this.$emit('updateEdit') // 更新父组件数据视图
                    }
                    return
                })
            }
        }
    }
</script>

<style>

    #EditJikeng .el-dialog__header {
      text-align: center;
        padding: 20px 30px 10px;
        /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      transition: unset;
    }

    #EditJikeng .el-dialog__body {
        padding: 10px 20px;
    }

    #EditJikeng .el-dialog__title{
      text-align: center;
        font-size: 18px;
        color: #fff;
    }

    #EditJikeng .el-select .el-input__inner{
        background: #FFF;
        color: #000;
    }

</style>

<style scoped>

    #map {
        width: 280px;
        height: 280px;
    }

    .form-group {
        margin-bottom: 15px;
    }

    label {
        display: inline-block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    .select{
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/components/project/EditJikeng.vue